<template>
<v-container>
  <v-card style="border-radius: 8px;">
    <v-container>
      <v-card-title class="primary--text"><h2 class="font-weight-regular">Unknown Keywords report</h2></v-card-title>
    <v-data-table
      :headers="headers"
      :items="cunknownkeywords"
    >
      <template v-slot:items="props">
        <td>{{ props.item.keyword }}</td>
        <td>{{ props.item.no_of_times_used }}</td>
        <td class="justify-center">
          <v-icon
            small
            @click="deleteKeyword(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
    </v-data-table>
    </v-container>
  </v-card>
  </v-container>
</template>

<script>
import {str,firebase} from '@/plugins/firebase.js';
import store from '../store';
  export default {
    data () {
      return {
        search: '',
        headers: [
          { text: 'Keyword', align: 'left', value: 'keyword'},
          { text: 'No.of times used', align: 'left', value: 'keywordUsedCount'},
          { text: '', value: 'name', sortable: false}
        ]
      }
    },
    methods:{
      deleteKeyword(item){
        let index = this.cunknownkeywords.indexOf(item)
        this.$store.dispatch('adeleteunknownkeyword',{index})
      }
    },
    computed:{
        cunknownkeywords(){
          if(this.$store.state.unknown_keywords != null){
          return this.$store.state.unknown_keywords
          }
          else{
            return []
          }
        }
    }
  }
</script>